"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native");

var _Griffe = _interopRequireDefault(require("../Assets/Griffe"));

var _Theme = require("../Theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = _reactNative.StyleSheet.create({
  bgGriffe: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: 200,
    backgroundColor: _Theme.darkColors.secondary,
    alignItems: 'center',
    justifyContent: 'center'
  }
});

var _default = function _default(_ref) {
  var animatedValue = _ref.animatedValue;
  var styleAnimatedTop = {};

  if (animatedValue) {
    styleAnimatedTop = {
      top: animatedValue.interpolate({
        inputRange: [0, 120, 130],
        outputRange: [0, 0, -10]
      })
    };
  }

  return /*#__PURE__*/_react["default"].createElement(_reactNative.Animated.View, {
    style: [styles.bgGriffe, styleAnimatedTop]
  }, /*#__PURE__*/_react["default"].createElement(_Griffe["default"], null));
};

exports["default"] = _default;